import React, { useContext, useEffect, useState } from 'react';
import { getInsightCountAndValuesData } from '../../../../constants/bank-statement-api';
import CircularProgress from '@material-ui/core/CircularProgress';
import { LeadData } from '../../../UploadedBankStatements/ManullyAddBankStaatements/ManuallyAddBankStatement';
import {
  tableArea,
  tableCells,
  tableRowCls,
  tableHeader,
  tableValues,
  loadingDiv
} from './OutFlowAndInflow.module.css';
import Switch from '@material-ui/core/Switch';
import { get } from 'lodash';
import numberFormat from '../../../../constants/NumberFormat';
const OutFlowAndInflow = () => {
  const leadDetails = useContext(LeadData);
  const [inflowLoading, setInflowLoading] = useState();
  const [outFlowLoding, setOutFlowLOading] = useState();
  const [inflowDaetail, setInFLowData] = useState({});
  const [outFlowDetail, setOutFLowData] = useState({});
  const [isValueSelected, setIsValSelected] = useState(false);
  const tablecell = `${tableCells} py-3 px-2 py-3 w-full`;
  const tablecellValues = `${tableValues}  items-center  text-right  px-3`;
  const tableRow = ` px-2  text-sm font-roboto   ${tableRowCls}`;

  const getFlowData = ({ type, handleLoading, setData }) => {
    handleLoading(true);
    getInsightCountAndValuesData({
      type: type,
      leadId: leadDetails?.leadId,
      applicantId: leadDetails?.applicantId,
      docId: leadDetails?.docId
    })
      .then(res => {
        handleLoading(false);
        setData(e => {
          return { [type]: res, ...(e || {}) };
        });
      })
      .catch(error => {
        handleLoading(false);
        setData(e => {
          return { [type]: null, ...(e || {}) };
        });
      });
  };

  useEffect(() => {
    let inflowData = {
      handleLoading: setInflowLoading,
      setData: setInFLowData
    };
    let outFlowData = {
      handleLoading: setOutFlowLOading,
      setData: setOutFLowData
    };
    if (isValueSelected) {
      getFlowData({ type: 'inflow_values', ...inflowData });
      getFlowData({ type: 'outflow_values', ...outFlowData });
    } else {
      getFlowData({ type: 'outflow_count', ...outFlowData });
      getFlowData({ type: 'inflow_count', ...inflowData });
    }
  }, [isValueSelected]);

  const outflowList = [
    {
      name: isValueSelected ? 'Total Outflow Value' : 'Total Outflow Count',
      count: 'total_outflow_count',
      values: 'total_outflow_values'
    },
    {
      name: 'Total Cash drew transaction',
      count: 'total_cash_withdrew',
      values: 'total_cash_withdrew_values'
    },
    {
      name: 'Total Cheque issued',
      count: 'total_cheque_issued',
      values: 'total_cheque_issued_values'
    },
    {
      name: 'Total ESC issued',
      count: 'total_ECS_issued',
      values: 'total_ECS_issued_values'
    },
    {
      name: 'Total charges',
      count: 'total_charges',
      values: 'total_charges_values'
    }
  ];
  const inflowList = [
    {
      name: isValueSelected ? 'Total Inflow Value' : 'Total Inflow Count',
      count: 'total_inflow_count',
      values: 'total_inflow_values'
    },
    {
      name: 'Total Salary',
      count: 'total_salary',
      values: 'total_salary_values'
    },
    {
      name: 'Total Cash deposit',
      count: 'total_cash_deposit',
      values: 'total_cash_deposit_values'
    },

    {
      name: 'Total cheque received',
      count: 'total_cheque_recieved',
      values: 'total_cheque_recieved_values'
    }
  ];

  const getValuesInNumberFormat = num => {
    if (!num) return '---';
    try {
      let number = parseFloat(num);
      return <span>₹{numberFormat(number)}</span>;
    } catch {
      return num;
    }
  };
  return (
    <div className="w-full">
      <div
        className="w-full mt-5 bg-white py-3 px-3 rounded"
        style={{ minHeight: '250px' }}
      >
        <p className="text-lg text-black-500 mb-3 font-bold">
          Outflow & Inflow
        </p>
        <hr className="w-full " style={{ borderColor: '#dee0f0' }} />
        <div className="table ml-auto mr-3">
          <div className="flex items-center">
            {!isValueSelected && (
              <span
                className={`font-normal text-xs text-black-500 font-roboto`}
              >
                Count
              </span>
            )}

            <Switch
              value={isValueSelected}
              onChange={() => setIsValSelected(e => !e)}
              color="primary"
            />
            {isValueSelected && (
              <span
                className={`font-normal text-xs text-black-500 font-roboto`}
              >
                Value
              </span>
            )}
          </div>
        </div>
        <div className="w-full ">
          <div className="flex  w-full  gap-4 overflow-auto hide-scroll-bar bg-white">
            <table className={`${tableArea}  rounded`}>
              <tr>
                <td
                  className={`${tableHeader} px-2 py-2 font-bold font-roboto `}
                >
                  Outflow
                </td>
              </tr>
              {outFlowLoding ? (
                <tr>
                  <td colSpan="2">
                    <div
                      className={`mx-auto table items-center mt-8 ${loadingDiv}`}
                    >
                      <CircularProgress />
                    </div>
                  </td>
                </tr>
              ) : (
                outflowList?.map((each, index) => (
                  <tr className={`${tableRow}`} key={`ouflow-count-${index}`}>
                    <td className={`${tablecell}`}>{each?.name}</td>
                    <td className={`${tablecellValues} `}>
                      {isValueSelected
                        ? getValuesInNumberFormat(
                            get(outFlowDetail, `outflow_values.${each.values}`)
                          )
                        : get(outFlowDetail, `outflow_count.${each.count}`) ||
                          '---'}
                    </td>
                  </tr>
                ))
              )}
            </table>

            <table className={`${tableArea}  rounded`}>
              <tr>
                <td
                  className={`${tableHeader} px-2 py-2 font-bold font-roboto `}
                >
                  Inflow
                </td>
              </tr>
              {inflowLoading ? (
                <tr>
                  <td colSpan="2">
                    <div
                      className={`mx-auto table items-center mt-8 ${loadingDiv}`}
                    >
                      <CircularProgress />
                    </div>
                  </td>
                </tr>
              ) : (
                inflowList?.map((each, index) => (
                  <tr className={`${tableRow}`} key={`inflow-count-${index}`}>
                    <td className={`${tablecell}`}>{each?.name}</td>
                    <td className={`${tablecellValues}`}>
                      {isValueSelected
                        ? getValuesInNumberFormat(
                            get(inflowDaetail, `inflow_values.${each.values}`)
                          )
                        : get(inflowDaetail, `inflow_count.${each.count}`) ||
                          '---'}
                    </td>
                  </tr>
                ))
              )}
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutFlowAndInflow;
